
<view-more-text-box :line-clamp="lineClamp" textBoxClasses="text-body-2 text-grey-body">{{ bio }}</view-more-text-box>
